import { computed } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import Store from "@/store";
import { MUTATION_TYPES } from "@/store/const";
import providers from "@/lib/api";

export default function useBalance() {
  const balance = computed(() => Store.state.userBalance);
  const { authUserStrict } = useAuthUser();

  const setBalance = (balance: number) => Store.commit(MUTATION_TYPES.SET_USER_BALANCE, balance);

  const getBalance = async () => {
    const balance = await providers.TransactionProvider.getBalance({ userIds: [authUserStrict.value.id] });
    setBalance(balance[authUserStrict.value.id]);
  };

  const subscribeBalanceUpdated = async (onData: (balance: number) => void) => {
    const observer = await providers.TransactionProvider.subscribeUserBalanceUpdated(onData);
    return () => observer.unsubscribe();
  };

  return {
    balance,
    getBalance,
    setBalance,
    subscribeBalanceUpdated,
  };
}
